// extracted by mini-css-extract-plugin
module.exports = {"music":"f9ff11","musicItem":"ce6bf1","musicInner":"_80b50e","musicInnerRecent":"_2e8ca4","musicInnerRecentItem":"_4654bf"};